import React from 'react';

const TermsOfServiceIcon: React.FC = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4173 1.45898H1.75V16.5932H15.25V9.02609"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.2168 7.50789L8.42108 11.9576L15.2499 1.40625"
      stroke="#00223C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TermsOfServiceIcon;
